import React from 'react';
import Text from 'components/Text';
import { Row } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import DownloadService from 'services/download.service';

const FloatingLabel: React.FC<any> = (props: any) => {
  const { uri, label, index, onRemove } = props;

  return (
    <Row
      className="bg-warning pl-2 pr-1 py-1 justify-between align-center m-1"
      style={{ borderRadius: 20 }}
    >
      {uri ? (
        <Text size={14} className="color-gray-90 cursor-pointer">
          <p
            role="presentation"
            onClick={() => DownloadService.CreateDownloadWithBlank(uri)}
          >
            {label}
          </p>
        </Text>
      ) : (
        <Text title='floatingText' size={14} className="color-white">
          {label}
        </Text>
      )}
      <Button
        onClick={() => onRemove(index)}
        className="bg-white ml-4"
        style={{ width: 18, height: '100%', borderRadius: '50%' }}
      >
        <Text className="color-warning font-bold">&times;</Text>
      </Button>
    </Row>
  );
};

export default FloatingLabel;
